/* eslint-disable filenames/match-regex */
const camelizeString = (snakeString = '') =>
  snakeString.trim().replace(/(-|_|\s)+(.)?/g, (_match, _sep, c) => (c ? c.toUpperCase() : ''));

const camelize = (snakeData = {}, recursive = false, blacklist = []) => {
  const camelData = Array.isArray(snakeData) ? [] : {};

  Object.keys(snakeData).forEach(key => {
    const camelKey = blacklist.includes(key) ? key : camelizeString(key, blacklist);
    if (recursive && snakeData[key] && typeof snakeData[key] === 'object') {
      camelData[camelKey] = camelize(snakeData[key], true, blacklist);
    } else {
      camelData[camelKey] = snakeData[key];
    }
  });

  return camelData;
};

const snakeifyString = (camelString = '') =>
  camelString
    .trim()
    .replace(/([a-z\d])([A-Z]+)/g, '$1_$2')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/[-\s]+/g, '_')
    .toLowerCase();

const snakeify = (camelData = {}, recursive = false) => {
  const snakeData = Array.isArray(camelData) ? [] : {};

  Object.keys(camelData).forEach(key => {
    const snakeKey = snakeifyString(key);
    if (recursive && camelData[key] && typeof camelData[key] === 'object') {
      snakeData[snakeKey] = snakeify(camelData[key], true);
    } else {
      snakeData[snakeKey] = camelData[key];
    }
  });

  return snakeData;
};

const kebabifyString = (camelString = '') =>
  camelString
    .trim()
    .replace(/([a-z\d])([A-Z]+)/g, '$1-$2')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1-$2')
    .replace(/[_\s]+/g, '-')
    .toLowerCase();

export { camelize, snakeify, camelizeString, snakeifyString, kebabifyString };



// WEBPACK FOOTER //
// ../utilities/object-utilities.js